import { patchState, signalStore, withMethods, withComputed, withState } from '@ngrx/signals';
import { computed } from '@angular/core';
import { environment } from 'src/environments/environment';
import { JobDetails } from '../../models/job-details.model';
import { initialJobDetailsSlice, JobDetailsSlice } from './job-details.slice';

export const JobDetailsStore = signalStore(
    { providedIn: 'root' },

    withState(initialJobDetailsSlice),

    withComputed((store) => ({
        snapshot: computed<JobDetailsSlice>(() => ({
            jobTitle: store.jobTitle(),
            jobId: store.jobId(),
            employmentType: store.employmentType(),
            facilityId: store.facilityId(),
            facilityName: store.facilityName(),
            facilityLocation: store.facilityLocation(),
            profession: store.profession(),
            professionId: store.professionId(),
            specialtyId: store.specialtyId(),
            specialty: store.specialty(),
            unitId: store.unitId(),
            unitFormId: store.unitFormId(),
            unitDescription: store.unitDescription(),
            accountManager: store.accountManager(),
            accountCoordinator: store.accountCoordinator(),
            billRate: store.billRate(),
            payPeriodTypesId: store.payPeriodTypesId()
        }))
    })),

    withMethods((store) => ({
        updateJobDetailsFromData: (data: JobDetails) => {
            patchState(store, { ...data });
        },

        getState: () => store,

        getSnapshot: () => store.snapshot()
    })),

    environment.storeWithDevTools('locums-margin-calculator-job-details-store')
);
